module.exports = __webpack_public_path__ + "assets/img/yl_w_d_i_12.325aba7b.jpg";